module["exports"] = [
  "#{city_name}",
  "#{city_prefix} #{Name.male_first_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/city.js
// module id = 1091
// module chunks = 0